import React from 'react';
import ConsumptionSummary from '../ConsumptionSummary';

// 租户管理员只读消费汇总，租户由服务端按绑定自动限定
const TenantAdminConsumption = () => <ConsumptionSummary tenantMode />;

export default TenantAdminConsumption;
